import { useAdminProfile } from './index.function';
import { HiArrowLeft } from 'react-icons/hi';
import { FaRegUser } from 'react-icons/fa';
import { Loader, LogOut, Text } from '../../components/index';
import { fontSizes } from '../../constants/constants';
import textWeight from '../../utils/textWeight';
const AdminProfile = ({ onBack, title = false }) => {
  const {
    isMenuOpen,
    showPopup,
    handleContinueClick,
    closePopup,
    userData,
    isLoading,
    handleMenuClick,
  } = useAdminProfile();
  const { TextWeight } = textWeight();
  return (
    <div
      className={`relative flex items-center ${
        onBack ? 'justify-between' : 'justify-end'
      }`}
    >
      <div className='flex items-center gap-5'>
        {onBack && (
          <div
            className='cursor-pointer bg-customBlack w-8 h-8 2xl:w-10 2xl:h-10 border border-customBlack hover:border-customBlack hover:bg-secondary flex justify-center items-center text-secondary rounded-full group transition-all duration-300 ease-in-out'
            onClick={onBack}
          >
            <HiArrowLeft className='text-lg group-hover:text-customBlack transition-colors duration-300 ease-in-out' />
          </div>
        )}
        {title && (
          <Text
            text={title}
            size={fontSizes.h28}
            weight={TextWeight.Raleway_ExtraBold}
            color='text-black'
            isTruncate={false}
          />
        )}
      </div>
      <div
        className='bg-primary rounded-full w-14 h-14 flex justify-center items-center cursor-pointer'
        onClick={handleMenuClick}
      >
        {isLoading ? (
          <Loader isprimary={false} />
        ) : userData?.data?.image ? (
          <img
            className='pb-1 rounded-full w-full h-full'
            src={userData.data.image}
            alt='User'
          />
        ) : (
          <FaRegUser className='text-2xl' />
        )}

        {isMenuOpen && (
          <div className='absolute right-0 bottom-[-2.5rem] mt-2 w-30 bg-white rounded-lg shadow-md overflow-hidden z-10'>
            <ul className='text-sm'>
              <li
                className='hover:bg-gray-100 px-4 py-1 cursor-pointer text-sm lg:text-base font-ralewaySemiBold'
                onClick={handleContinueClick}
              >
                Logout
              </li>
            </ul>
          </div>
        )}
      </div>
      {showPopup && <LogOut closePopup={closePopup} />}
    </div>
  );
};

export default AdminProfile;
